module.exports = __webpack_public_path__ + "img/ico_arrow_down_white.aa4e14f0.svg";